import axios from '@/libs/api.request'

// 获取首页模块列表
export const getHomeModuleList = (params) => {
  return axios.request({
    url: '/v2/admin/home/modules',
    method: 'get',
    params
  })
}

// 新增首页模块
export const createHomeModule = (data) => {
  return axios.request({
    url: '/v2/admin/home/modules',
    method: 'post',
    data
  })
}

// 编辑首页模块
export const updateHomeModule = (id, data) => {
  return axios.request({
    url: `/v2/admin/home/modules/${id}`,
    method: 'put',
    data
  })
}

// 删除首页模块
export const deleteHomeModule = (id) => {
  return axios.request({
    url: `/v2/admin/home/modules/${id}`,
    method: 'delete'
  })
}

// 更新模块状态
export const updateModuleStatus = (id, status) => {
  return axios.request({
    url: `/v2/admin/home/modules/${id}/status`,
    method: 'patch',
    data: { status }
  })
}

// 更新模块排序
export const updateModuleSort = (id, sort) => {
  return axios.request({
    url: `/v2/admin/home/modules/${id}/sort`,
    method: 'patch',
    data: { sort }
  })
}
